var cart = [
    {
      "Họ Tên": "Chị Trâm Anh",
      "Địa chỉ": "VPMQ",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 660,
      "color": "#FF0000",
      "latlong": "10.353739-105.444014",
      "notes": "Chị Trâm Anh-VPMQ-Đất trống-660 tr"
    },
    {
      "Họ Tên": "Chị Trâm Anh",
      "Địa chỉ": "VPMQ",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 620,
      "color": "#FF0000",
      "latlong": "10.353728-105.444320",
      "notes": "Chị Trâm Anh-VPMQ-Đất trống-620 tr"
    },
    {
      "Họ Tên": "Cô Út",
      "Địa chỉ": "VPMQ",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 610,
      "color": "#FF0000",
      "latlong": "10.353650-105.443758",
      "notes": "Cô Út-VPMQ-Đất trống-610 tr"
    },
    {
      "Họ Tên": "Dì Giang",
      "Địa chỉ": "KDC Trần Quang Khải",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 800,
      "color": "#FF0000",
      "latlong": "10.345457-105.456946",
      "notes": "Dì Giang-KDC Trần Quang Khải-Đất trống-800 tr"
    },
    {
      "Họ Tên": "CHỊ MAI - NHÀ DS8TDH",
      "Địa chỉ": "đường số 7 quẹo phải, đoạn giữa đường số 8, nhà thụt vào trong, có sân và rào sắt",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1650,
      "color": "#FF0000",
      "latlong": "10.366381-105.424687",
      "notes": "CHỊ MAI - NHÀ DS8TDH-đường số 7 quẹo phải, đoạn giữa đường số 8, nhà thụt vào trong, có sân và rào sắt-Cấp 4-1650 tr"
    },
    {
      "Họ Tên": "Chị Hoàng",
      "Địa chỉ": "Làng giáo viên Mỹ Hòa",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1000,
      "color": "#FF0000",
      "latlong": "10.362656-105.398550",
      "notes": "Chị Hoàng-Làng giáo viên Mỹ Hòa-Đất trống-1000 tr"
    },
    {
      "Họ Tên": "Chị Hoàng",
      "Địa chỉ": "Xẻo Trôm 3",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1250,
      "color": "#FF0000",
      "latlong": "10.365463-105.442814",
      "notes": "Chị Hoàng-Xẻo Trôm 3-Cấp 4-1250 tr"
    },
    {
      "Họ Tên": "A Nguyễn Minh Thảo",
      "Địa chỉ": "Xẻo Trôm 3",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 1550,
      "color": "#FF0000",
      "latlong": "10.365742-105.442547",
      "notes": "A Nguyễn Minh Thảo-Xẻo Trôm 3-1 trệt 1 lầu-1550 tr"
    },
    {
      "Họ Tên": "Anh Khan",
      "Địa chỉ": "Xẻo Trôm 5",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 1850,
      "color": "#FF0000",
      "latlong": "10.364180-105.433329",
      "notes": "Anh Khan-Xẻo Trôm 5-1 trệt 1 lầu-1850 tr"
    },
    {
      "Họ Tên": "Chị Hoàng",
      "Địa chỉ": "Khu Xẻo chanh",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 1850,
      "color": "#FF0000",
      "latlong": "10.369929-105.438745",
      "notes": "Chị Hoàng-Khu Xẻo chanh-1 trệt 1 lầu-1850 tr"
    },
    {
      "Họ Tên": "A BÌNH SG",
      "Địa chỉ": "Gần trường lái, chưa tới ngã 3 mỹ hòa",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 10600,
      "color": "#FF0000",
      "latlong": "10.375476-105.417029",
      "notes": "A BÌNH SG-Gần trường lái, chưa tới ngã 3 mỹ hòa-1 trệt 1 lầu-10600 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "gần cafe Là, đầu đường Lê trọng tấn",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3250,
      "color": "#FF0000",
      "latlong": "10.365086-105.428983",
      "notes": "G THU-gần cafe Là, đầu đường Lê trọng tấn-Đất trống-3250 tr"
    },
    {
      "Họ Tên": "A TOẢN",
      "Địa chỉ": "gần đầu công viên Ung văn khiêm, chạy vào tay trái có nền trống có chậu cây",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1200,
      "color": "#FF0000",
      "latlong": "10.376822-105.430979",
      "notes": "A TOẢN-gần đầu công viên Ung văn khiêm, chạy vào tay trái có nền trống có chậu cây-Đất trống-1200 tr"
    },
    {
      "Họ Tên": "GOLDEN CITY",
      "Địa chỉ": "Các lô nền trong golden",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 2400,
      "color": "#FF0000",
      "latlong": "10.383807-105.425455",
      "notes": "GOLDEN CITY-Các lô nền trong golden-Đất trống-2400 tr"
    },
    {
      "Họ Tên": "THÀNH THI VPB",
      "Địa chỉ": "đi bên trái đường cặp rạch, chạy tới gần cuối rạch, có cầu qua rạch",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1850,
      "color": "#FF0000",
      "latlong": "10.376237-105.425773",
      "notes": "THÀNH THI VPB-đi bên trái đường cặp rạch, chạy tới gần cuối rạch, có cầu qua rạch-Đất trống-1850 tr"
    },
    {
      "Họ Tên": "CÔ PHƯỢNG TDH",
      "Địa chỉ": "từ đường Kênh đào nối dài, quẹo trái vào nhánh 1 rồi quẹo phải vào nhánh 2",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 2600,
      "color": "#FF0000",
      "latlong": "10.369977-105.439209",
      "notes": "CÔ PHƯỢNG TDH-từ đường Kênh đào nối dài, quẹo trái vào nhánh 1 rồi quẹo phải vào nhánh 2-1 trệt 2 lầu-2600 tr"
    },
    {
      "Họ Tên": "A XUÂN CB",
      "Địa chỉ": "từ Ung văn khiêm, chưa qua cầu sắt, quẹo phải, chạy 200m tới quán cafe Khúc thụy du 2",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 7200,
      "color": "#FF0000",
      "latlong": "0.366786-105.437883",
      "notes": "A XUÂN CB-từ Ung văn khiêm, chưa qua cầu sắt, quẹo phải, chạy 200m tới quán cafe Khúc thụy du 2-Cấp 4-7200 tr"
    },
    {
      "Họ Tên": "CHỊ HOA EXIM",
      "Địa chỉ": "Cuối đường Ng BÌnh quẹo trái, nền sau nhà trắng",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3100,
      "color": "#FF0000",
      "latlong": "10.363291-105.428398",
      "notes": "CHỊ HOA EXIM-Cuối đường Ng BÌnh quẹo trái, nền sau nhà trắng-Đất trống-3100 tr"
    },
    {
      "Họ Tên": "A CHINH MB",
      "Địa chỉ": "Từ đường Kênh Đào nối dài chạy cuối đường, quẹo trái vào đường beton, có nhà trọ sv",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 4600,
      "color": "#FF0000",
      "latlong": "10.369781-105.439126",
      "notes": "A CHINH MB-Từ đường Kênh Đào nối dài chạy cuối đường, quẹo trái vào đường beton, có nhà trọ sv-Cấp 4-4600 tr"
    },
    {
      "Họ Tên": "A XUÂN CB",
      "Địa chỉ": "mặt tiền LTT nối dài, đoạn gần UVK",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 8222,
      "color": "#FF0000",
      "latlong": "10.372087-105.437189",
      "notes": "A XUÂN CB-mặt tiền LTT nối dài, đoạn gần UVK-Đất trống-8222 tr"
    },
    {
      "Họ Tên": "A NGHỊ - gởi nhà",
      "Địa chỉ": "Từ Tô hiến thành vào quẹo trái vào Dự định 6, nhà bên tay phải",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 3500,
      "color": "#FF0000",
      "latlong": "10.373569-105.445165",
      "notes": "A NGHỊ - gởi nhà-Từ Tô hiến thành vào quẹo trái vào Dự định 6, nhà bên tay phải -1 trệt 2 lầu-3500 tr"
    },
    {
      "Họ Tên": "CHỊ KIM - NAMA",
      "Địa chỉ": "Cuối đường số 5, gần góc ds1",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1700,
      "color": "#FF0000",
      "latlong": "10.364684-105.426214",
      "notes": "CHỊ KIM - NAMA-Cuối đường số 5, gần góc ds1-Đất trống-1700 tr"
    },
    {
      "Họ Tên": "A HÒA TDH",
      "Địa chỉ": "Nguyễn Minh Hồng tây đại học",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 3200,
      "color": "#FF0000",
      "latlong": "10.364594-105.426935",
      "notes": "A HÒA TDH-Nguyễn Minh Hồng tây đại học-1 trệt 2 lầu-3200 tr"
    },
    {
      "Họ Tên": "A HUY - Song Mai",
      "Địa chỉ": "gần ngã 3 Trường chinh - ng hữu thọ, nhà nằm nhìn ra Phạm cự lượng",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 2250,
      "color": "#FF0000",
      "latlong": "10.363671-105.442110",
      "notes": "A HUY - Song Mai-gần ngã 3 Trường chinh - ng hữu thọ, nhà nằm nhìn ra Phạm cự lượng-1 trệt 1 lầu-2250 tr"
    },
    {
      "Họ Tên": "KIÊN Bia",
      "Địa chỉ": "Lô 25R2 - Cuối đường Lê Duẩn, xẻo trôm, nhà bên tay phải",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 1850,
      "color": "#FF0000",
      "latlong": "10.366830-105.442155",
      "notes": "KIÊN Bia-Lô 25R2 - Cuối đường Lê Duẩn, xẻo trôm, nhà bên tay phải-1 trệt 1 lầu-1850 tr"
    },
    {
      "Họ Tên": "A DIỆU",
      "Địa chỉ": "đoạn đầu con đường, kế quán võng",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3000,
      "color": "#FF0000",
      "latlong": "10.368956-105.434750",
      "notes": "A DIỆU-đoạn đầu con đường, kế quán võng-Đất trống-3000 tr"
    },
    {
      "Họ Tên": "A HÒA  TDH",
      "Địa chỉ": "đường chính vào khu Tỉnh đoàn, nền nằm khúc giữa, tay phải, hàng cây thứ 3 từ góc dưới đếm lên",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1130,
      "color": "#FF0000",
      "latlong": "10.361123-105.428418",
      "notes": "A HÒA  TDH-đường chính vào khu Tỉnh đoàn, nền nằm khúc giữa, tay phải, hàng cây thứ 3 từ góc dưới đếm lên-Đất trống-1130 tr"
    },
    {
      "Họ Tên": "Chị Liên - Thục Phán",
      "Địa chỉ": "Chạy tới giữa đường Triệu quang phục, nhìn tay trái có hẻm lớn quẹo vào, chạy tới cuối hẻm nhà bên tay phải",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 3000,
      "color": "#FF0000",
      "latlong": "10.369659-105.448790",
      "notes": "Chị Liên - Thục Phán-Chạy tới giữa đường Triệu quang phục, nhìn tay trái có hẻm lớn quẹo vào, chạy tới cuối hẻm nhà bên tay phải-Cấp 4-3000 tr"
    },
    {
      "Họ Tên": "A PHÚ -  Gia Phú",
      "Địa chỉ": "mặt tiền LTT, gần đầu Ung Văn Khiêm, nền số 31,32",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 11100,
      "color": "#FF0000",
      "latlong": "10.371705-105.436563",
      "notes": "A PHÚ -  Gia Phú-mặt tiền LTT, gần đầu Ung Văn Khiêm, nền số 31,32-Đất trống-11100 tr"
    },
    {
      "Họ Tên": "CHỊ LOAN - hẻm VTS",
      "Địa chỉ": "hẻm đối diện đại học AG cũ, ngay chỗ bán cơm phần, quẹo vào hẻm chạy 40m bên tay trái có hẻm nhánh, vào hẻm 40m nữa tới nhà bên tay trái",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 1800,
      "color": "#FF0000",
      "latlong": "10.375613-105.433799",
      "notes": "CHỊ LOAN - hẻm VTS-hẻm đối diện đại học AG cũ, ngay chỗ bán cơm phần, quẹo vào hẻm chạy 40m bên tay trái có hẻm nhánh, vào hẻm 40m nữa tới nhà bên tay trái-1 trệt 2 lầu-1800 tr"
    },
    {
      "Họ Tên": "A KHÔN",
      "Địa chỉ": "gần cầu Ông Mạnh, kế nhà thuốc Ngân Phú",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 27000,
      "color": "#FF0000",
      "latlong": "10.377910-105.428420",
      "notes": "A KHÔN-gần cầu Ông Mạnh, kế nhà thuốc Ngân Phú-1 trệt 1 lầu-27000 tr"
    },
    {
      "Họ Tên": "GIA MSB",
      "Địa chỉ": "Hẻm 2 gần Hải Thượng Lãn Ông, từ đầu hẻm vào 50m, nhà nằm đoạn giữa hẻm, gần đoạn nhỏ thông ra HTLO",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1600,
      "color": "#FF0000",
      "latlong": "10.375203-105.440541",
      "notes": "GIA MSB-Hẻm 2 gần Hải Thượng Lãn Ông, từ đầu hẻm vào 50m, nhà nằm đoạn giữa hẻm, gần đoạn nhỏ thông ra HTLO-Cấp 4-1600 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Khu Nam Kinh, đối diện AGU",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 2200,
      "color": "#FF0000",
      "latlong": "10.372822-105.434167",
      "notes": "G THU-Khu Nam Kinh, đối diện AGU-Đất trống-2200 tr"
    },
    {
      "Họ Tên": "Chị Trâm Anh",
      "Địa chỉ": "kế nhà may Hằng",
      "Kết cấu": "1 trệt 3 lầu",
      "Giá (triệu)": 4600,
      "color": "#FF0000",
      "latlong": "10.385407-105.435315",
      "notes": "Chị Trâm Anh-kế nhà may Hằng-1 trệt 3 lầu-4600 tr"
    },
    {
      "Họ Tên": "Chị Trâm Anh",
      "Địa chỉ": "ngay ngã ba gần quán nhậu TSH",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3150,
      "color": "#FF0000",
      "latlong": "10.381829-105.448853",
      "notes": "Chị Trâm Anh-ngay ngã ba gần quán nhậu TSH-1 trệt 1 lầu-3150 tr"
    },
    {
      "Họ Tên": "Chị Hậu - sở tài chính",
      "Địa chỉ": "Dương Diên Nghệ vào dự án, quẹo trái vào đường số 7, nhà bên tay phải, cách góc 2 căn",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 2200,
      "color": "#FF0000",
      "latlong": "10.368380-105.453946",
      "notes": "Chị Hậu - sở tài chính-Dương Diên Nghệ vào dự án, quẹo trái vào đường số 7, nhà bên tay phải, cách góc 2 căn-1 trệt 2 lầu-2200 tr"
    },
    {
      "Họ Tên": "Chị Trâm Anh",
      "Địa chỉ": "",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3200,
      "color": "#FF0000",
      "latlong": "10.380040-105.446769",
      "notes": "Chị Trâm Anh--1 trệt 1 lầu-3200 tr"
    },
    {
      "Họ Tên": "Cô Phượng -  TDH",
      "Địa chỉ": "3 nền liền có rào B40, đường Hồ hảo hớn -  tây đại học",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1750,
      "color": "#FF0000",
      "latlong": "10.364909-105.426431",
      "notes": "Cô Phượng -  TDH-3 nền liền có rào B40, đường Hồ hảo hớn -  tây đại học-Đất trống-1750 tr"
    },
    {
      "Họ Tên": "Chị Thanh Sao Mai",
      "Địa chỉ": "",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 4300,
      "color": "#FF0000",
      "latlong": "10.365923-105.430562",
      "notes": "Chị Thanh Sao Mai--Cấp 4-4300 tr"
    },
    {
      "Họ Tên": "Chị Thanh Sao Mai",
      "Địa chỉ": "Bình Khánh 3",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1320,
      "color": "#FF0000",
      "latlong": "10.396122-105.414265",
      "notes": "Chị Thanh Sao Mai-Bình Khánh 3-Đất trống-1320 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "đoạn giữa Triệu thị trinh - ỷ lan",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3100,
      "color": "#FF0000",
      "latlong": "10.397233-105.415566",
      "notes": "G THU-đoạn giữa Triệu thị trinh - ỷ lan-Đất trống-3100 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Chạy vào Khu dân cư Trại cá giống, tới nhánh thứ 2 quẹo phải, nền tầm giữa đoạn đường",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1600,
      "color": "#FF0000",
      "latlong": "10.361847-105.448106",
      "notes": "G THU-Chạy vào Khu dân cư Trại cá giống, tới nhánh thứ 2 quẹo phải, nền tầm giữa đoạn đường-Đất trống-1600 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Nền số 9,10,11 - nhánh số 1 của LTT, gần cuối đường tay trái",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3645,
      "color": "#FF0000",
      "latlong": "10.371064-105.438108",
      "notes": "G THU-Nền số 9,10,11 - nhánh số 1 của LTT, gần cuối đường tay trái-Đất trống-3645 tr"
    },
    {
      "Họ Tên": "A Tuấn [C Kim]",
      "Địa chỉ": "Đường Nguyễn Văn Trỗi, phía sau N Văn Linh, Nền kế hàng rào B40, đối diện nhà trọ",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3800,
      "color": "#FF0000",
      "latlong": "10.364175-105.427520",
      "notes": "A Tuấn [C Kim]-Đường Nguyễn Văn Trỗi, phía sau N Văn Linh, Nền kế hàng rào B40, đối diện nhà trọ-Đất trống-3800 tr"
    },
    {
      "Họ Tên": "A Toản",
      "Địa chỉ": "Từ Quản cơ thành, quẹo trái vào Ngô lợi, chạy tới chút thì quẹo phải vào Nguyễn khuyến, nhà nằm đoạn giữa đường",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1200,
      "color": "#FF0000",
      "latlong": "10.396524-105.428793",
      "notes": "A Toản-Từ Quản cơ thành, quẹo trái vào Ngô lợi, chạy tới chút thì quẹo phải vào Nguyễn khuyến, nhà nằm đoạn giữa đường-Cấp 4-1200 tr"
    },
    {
      "Họ Tên": "A Hiền - Sa",
      "Địa chỉ": "Đường Dự Định 6, hẻm Thoại Ngọc Hầu, bên tay trái có nền nhà trống",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1500,
      "color": "#FF0000",
      "latlong": "10.378614-105.446166",
      "notes": "A Hiền - Sa-Đường Dự Định 6, hẻm Thoại Ngọc Hầu, bên tay trái có nền nhà trống-Đất trống-1500 tr"
    },
    {
      "Họ Tên": "CÔ THÙY - USA",
      "Địa chỉ": "Tân Tuyến - Tri Tôn",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": "",
      "color": "#FF0000",
      "latlong": "",
      "notes": "CÔ THÙY - USA-Tân Tuyến - Tri Tôn-Đất trống- tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1600,
      "color": "#FF0000",
      "latlong": "",
      "notes": "G THU--Đất trống-1600 tr"
    },
    {
      "Họ Tên": "A TÂM tiệm vàng",
      "Địa chỉ": "Df9 Golden",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3600,
      "color": "#FF0000",
      "latlong": "10.382999-105.422788",
      "notes": "A TÂM tiệm vàng-Df9 Golden-Đất trống-3600 tr"
    },
    {
      "Họ Tên": "Anh Sỹ",
      "Địa chỉ": "Hẻm nhà nghỉ Đồng hồ, chưa qua cầu quẹo trái, cách nhà hàng Tường Vy 300m",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 700,
      "color": "#FF0000",
      "latlong": "10.377635-105.417181",
      "notes": "Anh Sỹ-Hẻm nhà nghỉ Đồng hồ, chưa qua cầu quẹo trái, cách nhà hàng Tường Vy 300m-Đất trống-700 tr"
    },
    {
      "Họ Tên": "Gia - MSB",
      "Địa chỉ": "Từ LX chạy xuống qua cầu Rạch Gòi Lớn, quẹo phải chạy vào 300m, qua trường Trần Quang Khải là tới nhà. Nhà có tiệm tóc Tuyết Xuân",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1400,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Gia - MSB-Từ LX chạy xuống qua cầu Rạch Gòi Lớn, quẹo phải chạy vào 300m, qua trường Trần Quang Khải là tới nhà. Nhà có tiệm tóc Tuyết Xuân-Cấp 4-1400 tr"
    },
    {
      "Họ Tên": "A Giang - F6NTH",
      "Địa chỉ": "Kế Mì An Thái, kế quán cơm phần, BV Hạnh Phúc",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3500,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Giang - F6NTH-Kế Mì An Thái, kế quán cơm phần, BV Hạnh Phúc-1 trệt 1 lầu-3500 tr"
    },
    {
      "Họ Tên": "A Thắng Sacom",
      "Địa chỉ": "Từ LX xuống chưa tới đèn đỏ Trần Quang Khải, có đường hẻm quẹo vào 300m",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 850,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Thắng Sacom-Từ LX xuống chưa tới đèn đỏ Trần Quang Khải, có đường hẻm quẹo vào 300m-Cấp 4-850 tr"
    },
    {
      "Họ Tên": "Tất Tú Phương",
      "Địa chỉ": "Mina shop, số 21 Ngô Gia Tự",
      "Kết cấu": "1 trệt 5 lầu",
      "Giá (triệu)": 15000,
      "color": "#FF0000",
      "latlong": "10.383266-105.440290",
      "notes": "Tất Tú Phương-Mina shop, số 21 Ngô Gia Tự-1 trệt 5 lầu-15000 tr"
    },
    {
      "Họ Tên": "Tất Tú Phương",
      "Địa chỉ": "đoạn giữa đường Phan Thành Long, cách ngã quẹo 3 căn",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 7500,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Tất Tú Phương-đoạn giữa đường Phan Thành Long, cách ngã quẹo 3 căn-1 trệt 2 lầu-7500 tr"
    },
    {
      "Họ Tên": "Cô Chi - Nam Thành",
      "Địa chỉ": "Cafe Trúc Xanh, đối diện cty Agifish; kế nhà máy nước Bình Đức",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 13000,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Cô Chi - Nam Thành-Cafe Trúc Xanh, đối diện cty Agifish; kế nhà máy nước Bình Đức-Đất trống-13000 tr"
    },
    {
      "Họ Tên": "A Duy - Lộc Trời",
      "Địa chỉ": "Đối diện quán Nhật Thanh, gần vòng xoay Lạc Long Quân",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 5800,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Duy - Lộc Trời-Đối diện quán Nhật Thanh, gần vòng xoay Lạc Long Quân-1 trệt 1 lầu-5800 tr"
    },
    {
      "Họ Tên": "Cô Ngọc - hẻm Cầu Quay",
      "Địa chỉ": "Qua cầu Quay, chưa tới đường Quản Cơ Thành, bên tay phải có hẻm nhỏ, chạy vào hẻm tầm 100m",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1150,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Cô Ngọc - hẻm Cầu Quay-Qua cầu Quay, chưa tới đường Quản Cơ Thành, bên tay phải có hẻm nhỏ, chạy vào hẻm tầm 100m-Đất trống-1150 tr"
    },
    {
      "Họ Tên": "Chị Hoa Exim",
      "Địa chỉ": "Từ đường quán Thỏ Đế vào, qua cầu quẹo trái, chạy 300m có đường đất tay phải, quẹo vô là tới ruộng",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1050,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Chị Hoa Exim-Từ đường quán Thỏ Đế vào, qua cầu quẹo trái, chạy 300m có đường đất tay phải, quẹo vô là tới ruộng-Đất trống-1050 tr"
    },
    {
      "Họ Tên": "A Đạt SG - A Hùng",
      "Địa chỉ": "Qua cầu Trà Ôn, quẹo phải vào Đường Chùa Ông cặp vách Agifish, chạy nửa đường có con đường betong bên tay phải",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 6700,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Đạt SG - A Hùng-Qua cầu Trà Ôn, quẹo phải vào Đường Chùa Ông cặp vách Agifish, chạy nửa đường có con đường betong bên tay phải-Đất trống-6700 tr"
    },
    {
      "Họ Tên": "A Trí - Df12",
      "Địa chỉ": "đoạn giữa đường số 1, bên tay trái",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1100,
      "color": "#FF0000",
      "latlong": "10.399488-105.413309",
      "notes": "A Trí - Df12-đoạn giữa đường số 1, bên tay trái-Đất trống-1100 tr"
    },
    {
      "Họ Tên": "A Tuấn - Thục Phán",
      "Địa chỉ": "gần ngã 3 Thục Phán - Triệu Thị Trinh",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3400,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Tuấn - Thục Phán-gần ngã 3 Thục Phán - Triệu Thị Trinh-Đất trống-3400 tr"
    },
    {
      "Họ Tên": "A Trung - xây dựng",
      "Địa chỉ": "Cuối đường số 16, bình khánh 5",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3100,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A Trung - xây dựng-Cuối đường số 16, bình khánh 5-1 trệt 1 lầu-3100 tr"
    },
    {
      "Họ Tên": "A SANH",
      "Địa chỉ": "Gần ngã 3 Lê Hoàn - Lạc Long Quân",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1350,
      "color": "#FF0000",
      "latlong": "",
      "notes": "A SANH-Gần ngã 3 Lê Hoàn - Lạc Long Quân-Cấp 4-1350 tr"
    },
    {
      "Họ Tên": "Chị Hạnh",
      "Địa chỉ": "Làng Giáo Viên",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 850,
      "color": "#FF0000",
      "latlong": "10.361527-105.397774",
      "notes": "Chị Hạnh-Làng Giáo Viên-Đất trống-850 tr"
    },
    {
      "Họ Tên": "Chị Như Vietcom",
      "Địa chỉ": "Bình Khánh 5",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3300,
      "color": "#FF0000",
      "latlong": "10.389113-105.418425",
      "notes": "Chị Như Vietcom-Bình Khánh 5-Đất trống-3300 tr"
    },
    {
      "Họ Tên": "Cô Út",
      "Địa chỉ": "",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3200,
      "color": "#FF0000",
      "latlong": "10.384749-105.434941",
      "notes": "Cô Út--1 trệt 1 lầu-3200 tr"
    },
    {
      "Họ Tên": "Chị Diễm",
      "Địa chỉ": "khu B4",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 2000,
      "color": "#FF0000",
      "latlong": "10.373909-105.426753",
      "notes": "Chị Diễm-khu B4-Cấp 4-2000 tr"
    },
    {
      "Họ Tên": "anh Phong",
      "Địa chỉ": "Thoại Ngọc Hầu",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 4500,
      "color": "#FF0000",
      "latlong": "",
      "notes": "anh Phong-Thoại Ngọc Hầu-Đất trống-4500 tr"
    },
    {
      "Họ Tên": "Anh Toản",
      "Địa chỉ": "Lê Trọng Tấn",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 3200,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Anh Toản-Lê Trọng Tấn-Đất trống-3200 tr"
    },
    {
      "Họ Tên": "Anh Trình",
      "Địa chỉ": "Rạch Rích",
      "Kết cấu": "",
      "Giá (triệu)": "",
      "color": "#FF0000",
      "latlong": "",
      "notes": "Anh Trình-Rạch Rích-- tr"
    },
    {
      "Họ Tên": "Anh Vệ",
      "Địa chỉ": "F7-04-Golden City an giang",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 4000,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Anh Vệ-F7-04-Golden City an giang-Đất trống-4000 tr"
    },
    {
      "Họ Tên": "Chị Hằng",
      "Địa chỉ": "Trần Cảnh",
      "Kết cấu": "",
      "Giá (triệu)": 1400,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Chị Hằng-Trần Cảnh--1400 tr"
    },
    {
      "Họ Tên": "Chị Mi",
      "Địa chỉ": "Đỗ Nhuận, phía sau Phạm Cự Lượng",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 2700,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Chị Mi-Đỗ Nhuận, phía sau Phạm Cự Lượng-1 trệt 1 lầu-2700 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Lương Ngọc Quyến Mỹ Quý",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1600,
      "color": "#FF0000",
      "latlong": "",
      "notes": "G THU-Lương Ngọc Quyến Mỹ Quý-Đất trống-1600 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Thục Phán",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1470,
      "color": "#FF0000",
      "latlong": "",
      "notes": "G THU-Thục Phán-Đất trống-1470 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Xẻo Chanh",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1050,
      "color": "#FF0000",
      "latlong": "",
      "notes": "G THU-Xẻo Chanh-Đất trống-1050 tr"
    },
    {
      "Họ Tên": "Chị Tuyết",
      "Địa chỉ": "Hẻm 141-Nguyễn Thái Học",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 3350,
      "color": "#FF0000",
      "latlong": "10.385290-105.434476",
      "notes": "Chị Tuyết-Hẻm 141-Nguyễn Thái Học-1 trệt 1 lầu-3350 tr"
    },
    {
      "Họ Tên": "Cô Út",
      "Địa chỉ": "Văn phòng Mỹ Quý",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 620,
      "color": "#FF0000",
      "latlong": "10.353819-105.444195",
      "notes": "Cô Út-Văn phòng Mỹ Quý-Đất trống-620 tr"
    },
    {
      "Họ Tên": "Giàu -Cái Sao",
      "Địa chỉ": "Trần Nhật Duật",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 5600,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Giàu -Cái Sao-Trần Nhật Duật-1 trệt 1 lầu-5600 tr"
    },
    {
      "Họ Tên": "Hồng Hải",
      "Địa chỉ": "tỉnh lộ 943 định thành thoại sơn",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 6000,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Hồng Hải-tỉnh lộ 943 định thành thoại sơn-Đất trống-6000 tr"
    },
    {
      "Họ Tên": "A Trí - Df12",
      "Địa chỉ": "Ủy Ban Đông Xuyên",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 560,
      "color": "#FF0000",
      "latlong": "10.374126-105.424782",
      "notes": "A Trí - Df12-Ủy Ban Đông Xuyên-Đất trống-560 tr"
    },
    {
      "Họ Tên": "G THU",
      "Địa chỉ": "Hẻm gần lẩu cháo mắt heo",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 760,
      "color": "#FF0000",
      "latlong": "",
      "notes": "G THU-Hẻm gần lẩu cháo mắt heo-1 trệt 1 lầu-760 tr"
    },
    {
      "Họ Tên": "Quang - Nhi",
      "Địa chỉ": "Kim Đồng",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 3200,
      "color": "#FF0000",
      "latlong": "10.382381-105.446380",
      "notes": "Quang - Nhi-Kim Đồng-Cấp 4-3200 tr"
    },
    {
      "Họ Tên": "Sĩ-Exim",
      "Địa chỉ": "Đường số 9, BK",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 2600,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Sĩ-Exim-Đường số 9, BK-1 trệt 1 lầu-2600 tr"
    },
    {
      "Họ Tên": "Sĩ - Exim",
      "Địa chỉ": "Cuối hẻm 23-Hà Hoàng Hổ",
      "Kết cấu": "1 trệt 1 lầu",
      "Giá (triệu)": 850,
      "color": "#FF0000",
      "latlong": "10.374229-105.418272",
      "notes": "Sĩ - Exim-Cuối hẻm 23-Hà Hoàng Hổ-1 trệt 1 lầu-850 tr"
    },
    {
      "Họ Tên": "Anh Toản",
      "Địa chỉ": "Khu Tiến Đạt",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1850,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Anh Toản-Khu Tiến Đạt-Đất trống-1850 tr"
    },
    {
      "Họ Tên": "Anh Toản",
      "Địa chỉ": "Triệu Quang Phục phường MP",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": "",
      "color": "#FF0000",
      "latlong": "",
      "notes": "Anh Toản-Triệu Quang Phục phường MP-Đất trống- tr"
    },
    {
      "Họ Tên": "Chị Tuyết",
      "Địa chỉ": "Bình Khánh 3",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1350,
      "color": "#FF0000",
      "latlong": "10.397552-105.413536",
      "notes": "Chị Tuyết-Bình Khánh 3-Đất trống-1350 tr"
    },
    {
      "Họ Tên": "Anh Phong",
      "Địa chỉ": "",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1300,
      "color": "#FF0000",
      "latlong": "10.390230-105.419899",
      "notes": "Anh Phong--Cấp 4-1300 tr"
    },
    {
      "Họ Tên": "Chị Hằng",
      "Địa chỉ": "",
      "Kết cấu": "1 trệt 1 lửng 3 lầu",
      "Giá (triệu)": 5300,
      "color": "#FF0000",
      "latlong": "10.380756-105.442959",
      "notes": "Chị Hằng--1 trệt 1 lửng 3 lầu-5300 tr"
    },
    {
      "Họ Tên": "Chị Hoàng Yến",
      "Địa chỉ": "C50-2 Tây sông hậu",
      "Kết cấu": "1 trệt 2 lầu",
      "Giá (triệu)": 3400,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Chị Hoàng Yến-C50-2 Tây sông hậu-1 trệt 2 lầu-3400 tr"
    },
    {
      "Họ Tên": "Chị Tuyết",
      "Địa chỉ": "B4",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1350,
      "color": "#FF0000",
      "latlong": "10.375834-105.428318",
      "notes": "Chị Tuyết-B4-Đất trống-1350 tr"
    },
    {
      "Họ Tên": "Anh Thái Hòa",
      "Địa chỉ": "Tây đại học",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1630,
      "color": "#FF0000",
      "latlong": "10.364979-105.425933",
      "notes": "Anh Thái Hòa-Tây đại học-Đất trống-1630 tr"
    },
    {
      "Họ Tên": "Trâm - ĐôngAbank",
      "Địa chỉ": "Tây đại học",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1800,
      "color": "#FF0000",
      "latlong": "10.365356-105.426317",
      "notes": "Trâm - ĐôngAbank-Tây đại học-Đất trống-1800 tr"
    },
    {
      "Họ Tên": "Chị Thanh Mai",
      "Địa chỉ": "Tây đại học",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1700,
      "color": "#FF0000",
      "latlong": "10.367069-105.424736",
      "notes": "Chị Thanh Mai-Tây đại học-Cấp 4-1700 tr"
    },
    {
      "Họ Tên": "Chị Thanh Hằng",
      "Địa chỉ": "Tây đại học",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1500,
      "color": "#FF0000",
      "latlong": "10.366392-105.424738",
      "notes": "Chị Thanh Hằng-Tây đại học-Đất trống-1500 tr"
    },
    {
      "Họ Tên": "Chị Thanh Mai",
      "Địa chỉ": "",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1700,
      "color": "#FF0000",
      "latlong": "10.365086-105.427595",
      "notes": "Chị Thanh Mai--Đất trống-1700 tr"
    },
    {
      "Họ Tên": "Nhật Thanh",
      "Địa chỉ": "",
      "Kết cấu": "Đất trống",
      "Giá (triệu)": 1450,
      "color": "#FF0000",
      "latlong": "",
      "notes": "Nhật Thanh--Đất trống-1450 tr"
    },
    {
      "Họ Tên": "Chị Tuyết",
      "Địa chỉ": "Bình Khánh 3",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 1500,
      "color": "#FF0000",
      "latlong": "10.399062-105.413394",
      "notes": "Chị Tuyết-Bình Khánh 3-Cấp 4-1500 tr"
    },
    {
      "Họ Tên": "Nguyễn Minh Thảo",
      "Địa chỉ": "khu 8 kỳ",
      "Kết cấu": "Cấp 4",
      "Giá (triệu)": 860,
      "color": "#FF0000",
      "latlong": "10.367927-105.445412",
      "notes": "Nguyễn Minh Thảo-khu 8 kỳ-Cấp 4-860 tr"
    }
  ];

export default cart;